import gql from 'graphql-tag'

// Use strings rather than fragment to prevent apollo-client heuristic issue.
// They work the same way seems like
// Old: fragment LoadCartFragment on carts {}
// New: ${CART_FRAGMENT}
const CART_FRAGMENT = `
  id
  address
  customer_details
  recipient_details
  delivery_address
  deliver_by
  delivery_distance
  delivery_eta
  delivery_charge
  discount_id
  inserted_at
  merchant_id
  order_coordinates
  fulfillment_type
  fulfillment_time_range
  pickup_store_id
  discount_code: discounts_cache(path: "code")
  discount_amount: discounts_cache(path: "total_discount")
  discount_target: discounts_cache(path: "target")
  discount_value: discounts_cache(path: "value")
  discount_type: discounts_cache(path: "type")
  pickup_store: storeByPickupStoreId {
    name
    settings
    address {
      line_2
      city
      zip
    }
  }
  cart_items: order_items {
    id
    is_valid
    product_variant_id
    order_id
    quantity
    vat
    variant_price
    variant_vat
    amount
    applied_modifiers {
      id
      amount
      quantity
      modifier_id
      modifier {
        id
        name
        restrictions
      }
      modifier_group_id
      modifier_group {
        id
        name
      }
    }
    product_variant {
      restrictions
      options
      product {
        id
        name
        category {
          id
          name
        }
      }
    }
  }
  pickup_date
  postcode
  store_id
  store {
    name
    slug
    delivery_interval: settings(path: "delivery_interval")
    pickup_interval: settings(path: "pickup_interval")
    advanced_special_schedules
    settings
    store_variants {
      variant_id
      in_stock
      published_at
    }
    sameday_delivery_minimum_order_value
    preorder_delivery_minimum_order_value
  }
  updated_at
  is_preorder
  metadata
  merchant {
    name
    slug
    id
    checkout_version_delivery
    checkout_version_pickup
    order_note_placeholder: setting(path: "order_note_placeholder")
    gift_wrap_text: setting(path: "gift_wrap_text")
    gift_wrap_price: setting(path: "gift_wrap_price")
    gift_wrap_enabled: setting(path: "gift_wrap_enabled")
    delivery_note_placeholder: setting(path: "delivery_note_placeholder")
  }
  additional_store_fee_cache
  order_notes
  dropoff_notes
  gift_wrap_message
`

const QUERY_GET_CART = gql`
  query getCartById($id: uuid!) {
    cart: carts_by_pk(id: $id) {
      ${CART_FRAGMENT}
    }
  }

`

const MUTATE_INIT_CART = gql`
  mutation createCart(
    $storeId: uuid!
    $merchantId: uuid!
    $pickupStoreId: uuid
    $customerId: uuid
    $fulfillmentType: FulfillmentType!
    $address: String
    $datetime: String
    $tz: String
    $lat: Float
    $lng: Float
    $fulfillmentTimeRange: String
    $useCustomerDefaultAddress: Boolean
    $metadata: String
    $deliveryAddress: DeliveryAddressParams
  ) {
    createNewCart(
      storeId: $storeId
      merchantId: $merchantId
      pickupStoreId: $pickupStoreId
      customerId: $customerId
      fulfillmentType: $fulfillmentType
      address: $address
      datetime: $datetime
      tz: $tz
      lat: $lat
      lng: $lng
      fulfillmentTimeRange: $fulfillmentTimeRange
      metadata: $metadata
      deliveryAddress: $deliveryAddress
      useCustomerDefaultAddress: $useCustomerDefaultAddress
    ) {
      id
    }
  }
`

const MUTATE_UPDATE_CART_ITEM = gql`
  mutation updateCart(
    $cartId: uuid!
    $amount: numeric!
    $variantId: uuid!
    $quantity: Int!
    $id: uuid!
    $vat: numeric!
    $variantPrice: numeric!
    $variantVat: numeric
  ) {
    update_order_items(
      where: { id: { _eq: $id }, product_variant_id: { _eq: $variantId } }
      _set: {
        amount: $amount
        quantity: $quantity
        vat: $vat
        updated_at: "NOW()"
      }
    ) {
      returning {
        cart {
          ${CART_FRAGMENT}
        }
      }
    }
  }
`

const MUTATE_ADD_TO_CART = gql`
  mutation addToCart(
    $cartId: uuid!
    $amount: numeric
    $variantId: uuid!
    $quantity: Int
    $id: uuid!
    $vat: numeric!
    $variantVat: numeric
    $variantPrice: numeric
    $appliedModifiers: applied_modifiers_arr_rel_insert_input
  ) {
    insert_order_items(
      objects: {
        id: $id
        cart_id: $cartId
        amount: $amount
        product_variant_id: $variantId
        quantity: $quantity
        inserted_at: "NOW()"
        updated_at: "NOW()"
        vat: $vat
        variant_price: $variantPrice
        variant_vat: $variantVat
        applied_modifiers: $appliedModifiers
      }
    ) {
      returning {
        cart {
          ${CART_FRAGMENT}
        }
      }
    }
  }
`

const MUTATE_REMOVE_CART_ITEM = gql`
  mutation deleteOrderItem($cartId: uuid!, $id: uuid!) {
    delete_applied_modifiers(where: { order_item_id: { _eq: $id } }) {
      affected_rows
    }
    delete_order_items(where: { id: { _eq: $id }, cart_id: { _eq: $cartId } }) {
      affected_rows
    }
  }
`

const MUTATE_CLEAR_CART = gql`
  mutation clearCart($cartId: uuid!) {
    delete_applied_modifiers(
      where: { order_item: { cart_id: { _eq: $cartId } } }
    ) {
      affected_rows
    }
    delete_order_items(where: { cart_id: { _eq: $cartId } }) {
      affected_rows
    }
  }
`

export {
  QUERY_GET_CART,
  MUTATE_INIT_CART,
  MUTATE_UPDATE_CART_ITEM,
  MUTATE_ADD_TO_CART,
  MUTATE_REMOVE_CART_ITEM,
  MUTATE_CLEAR_CART
}
